import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/calendar.svg")